import { useLocalStorage } from 'client/shared/helpers/hooks';
import React from 'react';

const localStorageSandboxAiAssistantIdKey = 'sandbox-ai-assistant-id';

export function useSandboxAiAssistantId() {
  const localStorage = useLocalStorage();
  const [assistantId, setAssistantId] = React.useState(
    localStorage?.getItem(localStorageSandboxAiAssistantIdKey) ?? ''
  );

  const setter = (newId: string) => {
    setAssistantId(newId);
    localStorage?.setItem(localStorageSandboxAiAssistantIdKey, newId);
  };
  return [assistantId, setter] as const;
}
